import * as i0 from '@angular/core';
import { inject, Injectable } from '@angular/core';
import { LOCAL_STORAGE } from '@ng-web-apis/common';
const DEFAULT_SERIALIZE = v => String(v);
let NgDocStoreService = /*#__PURE__*/(() => {
  class NgDocStoreService {
    constructor() {
      this.localStorage = inject(LOCAL_STORAGE);
    }
    set(key, data, serialize = DEFAULT_SERIALIZE) {
      return this.localStorage.setItem(key, serialize(data));
    }
    get(key, deserialize) {
      return deserialize ? deserialize(this.localStorage.getItem(key)) : this.localStorage.getItem(key);
    }
    static {
      this.ɵfac = function NgDocStoreService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgDocStoreService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: NgDocStoreService,
        factory: NgDocStoreService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return NgDocStoreService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NgDocStoreService };
